import React, { useEffect, useRef, useState } from 'react';

export default function ShortlistSearch({ value, onChange, label, closeLabel }) {
  const [expanded, setExpanded] = useState(false);
  const input = useRef(null);
  const trigger = useRef(null);
  useEffect(() => { if (expanded) input.current?.focus(); }, [expanded]);
  const close = () => { onChange(''); setExpanded(false); trigger.current?.focus(); };
  return <div className={`sl-expand-search ${expanded ? 'is-expanded' : ''}`} onKeyDown={event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
  }}>
    <button ref={trigger} className="sl-icon-button" title={label} aria-label={label} aria-expanded={expanded}
      onClick={() => { setExpanded(true); input.current?.focus(); }}><i className="fa-solid fa-magnifying-glass" aria-hidden="true" /></button>
    {expanded && <><input ref={input} aria-label={label} placeholder={label} value={value} onChange={event => onChange(event.target.value)} />
      <button className="sl-icon-button sl-search-close" title={closeLabel} aria-label={closeLabel} onClick={close}><i className="fa-solid fa-xmark" aria-hidden="true" /></button></>}
  </div>;
}
